

import React, { useRef } from 'react'
import { Box, useTexture } from '@react-three/drei'
import { PreviewDestinationOutlines } from "../../PreviewDestinationOutlines"

export function Window({ showDestinationOutline, ...props }) {
    const group = useRef()

    return (
        <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {e.stopPropagation() 
            props.clickFunction()}}>
            <Box position={[0,0.5,0]} args={[1, 1, 0.05]} radius={0.05} smoothness={4} >
                <meshPhongMaterial
                    receiveShadow
                    color={props.colour}
                    attach="material"
                    opacity={1}
                    
                />
                {showDestinationOutline && <PreviewDestinationOutlines />}
            </Box>
        </group>
    )
}
 
export function WindowTexture({ showDestinationOutline, ...props }) {

    const texture = useTexture(props.imageTexture)
    const group = useRef()

    return (
        <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {e.stopPropagation() 
            props.clickFunction()}}>
            <Box position={[0,0.5,0]} args={[1, 1, 0.05]} radius={0.05} smoothness={4} >
                <meshPhongMaterial
                    receiveShadow
                    color={props.colour}
                    attach="material"
                    opacity={1} transparent
                    map={texture}

                    
                />
                {showDestinationOutline && <PreviewDestinationOutlines />}
            </Box>
        </group>
    )
}
 